import React, { useState, useEffect } from "react"
import { Link } from "gatsby"
import { AnchorLink } from "gatsby-plugin-anchor-links"
import { GatsbyImage, StaticImage } from "gatsby-plugin-image"
import Button from "./button"
import ConditionButton from "./condition-button"
import "../styles.scss"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons"
import IconResourcesArrow from "../../images/icon-resources-arrow.svg"

export default function MobileSubMenu(props) {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    if (
      document.location.pathname === "/gist-hcp/"
    ) {
      const gistMobileNavItems = document.querySelectorAll(".MobileSubMenu a");
      gistMobileNavItems.forEach(item => {
        item.addEventListener("click", (e) => {
          e.preventDefault();
          window.scrollTo({
            top: document.querySelector(e.target.hash).offsetTop,
            behavior: "smooth"
          })
        });
      });
    }

    // Highlight parent menu
    const currentPath = document.location.pathname;
    const parentMenuItems = document.querySelectorAll("#mobile-impact-of-ism-nav-item, #mobile-efficacy-nav-item, #mobile-patient-perspectives-nav-item, #mobile-resources-nav-item");
    parentMenuItems.forEach(item => {
      if (currentPath.includes("impact-of-ism") && item.id === "mobile-impact-of-ism-nav-item") {
        item.classList.add("submenu-active");
      } else if (currentPath.includes("efficacy") && item.id === "mobile-efficacy-nav-item") {
        item.classList.add("submenu-active");
      } else if (currentPath.includes("patient-perspectives") && item.id === "mobile-patient-perspectives-nav-item") {
        item.classList.add("submenu-active");
      } else if (currentPath.includes("resources") && item.id === "mobile-resources-nav-item") {
        item.classList.add("submenu-active");
      }
  });
  }, [])

  const toggleActiveClass = (e, id) => {
    e.preventDefault();
    const currentState = isActive;
    setIsActive(currentState === id ? false : id);
  }

  const handleMobileSubMenuItems = props => {
    switch (props.site) {
      case "ism":
        return (
          <>
            {/* Nav - Impact of ISM */}
            <a
              type="ism"
              id="mobile-impact-of-ism-nav-item"
              onClick={(e) => toggleActiveClass(e, "impact-of-ism")}
              className={`mobile-subnav-nav-item mobile-subnav ${isActive === "impact-of-ism" ? "active" : ""}`}
            >
              <span
                onClick={(e) => toggleActiveClass(e, "impact-of-ism")}
                className="mobile-subnav"
                activeClassName="nav-active"
              >
                Impact of ISM
              </span>
              <img
                src={IconResourcesArrow}
                onClick={(e) => toggleActiveClass(e, "impact-of-ism")}
                className="mobile-subnav"
              />
            </a>
            {isActive === "impact-of-ism" && (
              <div id="impact-of-ism-subitem-container" 
                   className="mobile-subitem-container">
                <AnchorLink to="/ism/impact-of-ism/about-ism" type="ism">
                  About ISM
                </AnchorLink>
                <AnchorLink
                  to="/ism/impact-of-ism/burden-ism"
                  type="ism"
                >
                  Burden of ISM
                </AnchorLink>
                <a aria-hidden="true" role="presentation"></a>
                <a aria-hidden="true" role="presentation"></a>
                <a aria-hidden="true" role="presentation"></a>
                <a aria-hidden="true" role="presentation"></a>
                <a aria-hidden="true" role="presentation"></a>
              </div>
            )}

            <AnchorLink to="/ism/about-ayvakit/" type="ism">
              About AYVAKIT
            </AnchorLink>

            {/* Nav - Efficacy */}
            <a
              type="ism"
              id="mobile-efficacy-nav-item"
              onClick={(e) => toggleActiveClass(e, "efficacy")}
              className={`mobile-subnav-nav-item mobile-subnav ${isActive === "efficacy" ? "active" : ""}`}
            >
              <span
                onClick={(e) => toggleActiveClass(e, "efficacy")}
                className="mobile-subnav"
                activeClassName="nav-active"
              >
                Efficacy
              </span>
              <img
                src={IconResourcesArrow}
                onClick={(e) => toggleActiveClass(e, "efficacy")}
                className="mobile-subnav"
              />
            </a>
            {isActive === "efficacy" && (
              <div id="efficacy-subitem-container"
                className="mobile-subitem-container">
                <AnchorLink to="/ism/efficacy/pioneer-study-design/" type="ism">
                  PIONEER Study Design
                </AnchorLink>
                <AnchorLink
                  to="/ism/efficacy/"
                  type="ism"
                  className="efficacy-subpage"
                >
                  Efficacy
                </AnchorLink>
                <a aria-hidden="true" role="presentation"></a>
                <a aria-hidden="true" role="presentation"></a>
                <a aria-hidden="true" role="presentation"></a>
                <a aria-hidden="true" role="presentation"></a>
                <a aria-hidden="true" role="presentation"></a>
              </div>
            )}

            <AnchorLink to="/ism/safety/" type="ism">
              Safety
            </AnchorLink>
            <AnchorLink to="/ism/dosing/" type="ism">
              Dosing
            </AnchorLink>

            {/* Nav - Patient Perspectives */}
            <a
              type="ism"
              id="mobile-patient-perspectives-nav-item"
              onClick={(e) => toggleActiveClass(e, "patient-perspectives")}
              className={`mobile-subnav-nav-item mobile-subnav ${isActive === "patient-perspectives" ? "active" : ""}`}
            >
              <span
                onClick={(e) => toggleActiveClass(e, "patient-perspectives")}
                className="mobile-subnav"
                activeClassName="nav-active"
              >
                Patient Perspectives
              </span>
              <img
                src={IconResourcesArrow}
                onClick={(e) => toggleActiveClass(e, "patient-perspectives")}
                className="mobile-subnav"
              />
            </a>
            {isActive === "patient-perspectives" && (
              <div id="patient-perspectives-subitem-container" 
                   className="mobile-subitem-container">
                <AnchorLink to="/ism/patient-perspectives/stories/" type="ism">
                  Patient Stories
                </AnchorLink>
                <AnchorLink
                  to="/ism/patient-perspectives/profiles/"
                  type="ism"
                >
                  Patient Profiles
                </AnchorLink>
                <a aria-hidden="true" role="presentation"></a>
                <a aria-hidden="true" role="presentation"></a>
                <a aria-hidden="true" role="presentation"></a>
                <a aria-hidden="true" role="presentation"></a>
                <a aria-hidden="true" role="presentation"></a>
              </div>
            )}

            {/* Nav - Resources */}
            <a
              type="ism"
              id="mobile-resources-nav-item"
              onClick={(e) => toggleActiveClass(e, "resources")}
              className={`mobile-subnav-nav-item mobile-subnav ${isActive === "resources" ? "active" : ""}`}
            >
              <span
                onClick={(e) => toggleActiveClass(e, "resources")}
                className="mobile-subnav"
                activeClassName="nav-active"
              >
                Resources
              </span>
              <img
                src={IconResourcesArrow}
                onClick={(e) => toggleActiveClass(e, "resources")}
                className="mobile-subnav"
              />
            </a>
            {isActive === "resources" && (
              <div id="resources-subitem-container"
                className="mobile-subitem-container">
                <AnchorLink to="/ism/resources/access-support" type="ism">
                  Access and Support
                </AnchorLink>
                <AnchorLink to="/ism/resources/practice-resources" type="ism">
                  Practice Resources
                </AnchorLink>
                <AnchorLink
                  to="/ism/resources/patient-resources/"
                  type="ism"
                >
                  Patient Resources
                </AnchorLink>
                <AnchorLink to="/ism/resources/faqs/" type="ism">
                  FAQs
                </AnchorLink>
                <AnchorLink to="/ism/connect-with-us/" type="ism">
                  Connect with Us
                </AnchorLink>
                <a
                  href="https://www.ayvakit.com/"
                  target="_blank"
                  rel="noreferrer"
                  className="sm-peer-directory-nav-item"
                >
                  <span>SM Peer Directory</span>
                  <FontAwesomeIcon icon={faExternalLinkAlt} />
                </a>
              </div>
            )}
          </>
        )
      case "advsm":
        return (
          <>
            <Link to="/advsm/efficacy-data/" type="advsm">
              Efficacy Data
            </Link>
            <Link to="/advsm/safety-data/" type="advsm">
              Safety Data
            </Link>
            <Link to="/advsm/dosing/" type="advsm">
              Dosing
            </Link>
            <Link to="/advsm/patient-profiles/" type="advsm">
              Patient Profiles
            </Link>
            <Link to="/advsm/resources/" type="advsm">
              Resources
            </Link>
          </>
        )
      case "gist":
        return (
          <>
            <a href="/gist-hcp/#about-ayvakit" type="gist">
              About AYVAKIT
            </a>
            <a href="/gist-hcp/#resources" type="gist">
              Resources
            </a>
            <a href="/gist-hcp/#contact-us" type="gist">
              Contact Us
            </a>
            <a href="/gist-hcp/#support-program" type="gist">
              Support Program
            </a>
          </>
        )
      default:
        return console.log("not here")
    }
  }

  return <div className="MobileSubMenu">{handleMobileSubMenuItems(props)}</div>
}
